import { ABS_SECTOR_GROUP_KEY } from './AbsSectorGroup';
import type { AbsSectorGroupKey, IAbsSectorGroup } from './AbsSectorGroup';

export const AUTO_SECTOR_ID = '2fdca575-19e7-41cc-858e-9bb0981ce3a9';
export const CREDIT_CARD_SECTOR_ID = 'e04b093b-fa1d-4606-9474-135d9028e6e4';
export const EQUIPMENT_SECTOR_ID = 'a8439941-6dd1-4012-91c2-8a11d93ec4f6';
export const ESOTERIC_SECTOR_ID = 'f569da47-8ec0-47ac-ad0c-0ef3e68a5967';
export const STUDENT_LOAN_SECTOR_ID = '78ceddfe-5c7f-4c62-a18a-ee9b61e2a1b8';
export const CLO_SECTOR_ID = 'b5c805a6-b5c5-41f0-a6a3-1657cf9e67b6';
export const CMBS_SECTOR_ID = 'd023f155-2b59-46d8-8332-82d8f4ff33d5';
export const RMBS_SECTOR_ID = '012ba6d5-f89e-4b36-a336-2d9ef9a5b257';

export const ABS_SECTOR_PRESETS = [
  { id: CLO_SECTOR_ID, label: 'CLO' },
  { id: CMBS_SECTOR_ID, label: 'CMBS' },
  { id: RMBS_SECTOR_ID, label: 'RMBS' },
];

export const OTHER_SECTOR = {
  name: 'Other',
  abbreviation: 'OTHR',
  color: '#BFCCD8',
};

export const ABS_ACTIVE_CALENDAR_SECTOR_ORDER: string[] = [
  AUTO_SECTOR_ID,
  CREDIT_CARD_SECTOR_ID,
  EQUIPMENT_SECTOR_ID,
  ESOTERIC_SECTOR_ID,
  STUDENT_LOAN_SECTOR_ID,
  CLO_SECTOR_ID,
  CMBS_SECTOR_ID,
  RMBS_SECTOR_ID,
];

export const ABS_SECTOR_GROUPS: IAbsSectorGroup[] = [
  {
    key: ABS_SECTOR_GROUP_KEY.ABS,
    label: 'ABS',
    sectorIds: [
      AUTO_SECTOR_ID,
      CREDIT_CARD_SECTOR_ID,
      EQUIPMENT_SECTOR_ID,
      ESOTERIC_SECTOR_ID,
      STUDENT_LOAN_SECTOR_ID,
    ],
  },
  { key: ABS_SECTOR_GROUP_KEY.CLO, label: 'CLOs', sectorIds: [CLO_SECTOR_ID] },
  { key: ABS_SECTOR_GROUP_KEY.CMBS, label: 'CMBS', sectorIds: [CMBS_SECTOR_ID] },
  { key: ABS_SECTOR_GROUP_KEY.RMBS, label: 'RMBS', sectorIds: [RMBS_SECTOR_ID] },
];

export const ALL_ABS_SECTOR_GROUP_KEYS: AbsSectorGroupKey[] = ABS_SECTOR_GROUPS.map(({ key }) => key);
